var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-form-flat"},[_c('form',{attrs:{"id":"payment-form","action":"/charge","method":"post"}},[_c('div',{staticClass:"stripe-form"},[_c('div',{ref:"card-element",staticClass:"card-element"}),_c('div',{attrs:{"id":"card-errors","role":"alert"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }